export const COLORS = ['danger', 'warning', 'success', 'primary', 'neutral'];
export const VARIANTS = ['filled', 'light', 'lighter', 'outlined'];

export const getColorShade = (color) => (color === 'neutral' ? 700 : 500);

export const getBackgroundClass = (color, variant) => {
  const shade = getColorShade(color);
  switch (variant) {
    case 'filled':
      return `bg-${color}-${shade}`;
    case 'light':
      // Special case: primary color with light variant should use 50 instead of 100
      if (color === 'primary') {
        return 'bg-primary-50';
      }
      return `bg-${color}-100`;
    case 'lighter':
      // Special case: primary color with lighter variant should use 25 instead of 50
      if (color === 'primary') {
        return 'bg-primary-25';
      }
      return `bg-${color}-50`;
    case 'outlined':
      return 'bg-white';
    default:
      return `bg-${color}-50`;
  }
};

export const getBorderClass = (color, variant) => {
  if (variant === 'lighter') {
    const borderColor = color;
    return `border border-solid border-${borderColor}-200`;
  }
  if (variant === 'outlined') {
    return '!border-b border-solid border-0 border-neutral-200 rounded-none';
  }
};

export const getShade = (_variant) => {
  // Outlined variant now uses only bottom border, no shadow
};

export const getIconColor = (color, variant) => {
  if (variant === 'filled') return 'white';
  return color;
};

export const getIconShade = (color, variant) => {
  if (variant === 'filled') return undefined;
  return getColorShade(color);
};

export const getTextClass = (color, variant, isTitle) => {
  if (variant === 'filled') return 'text-white';
  const shade = isTitle ? 900 : 800;
  return `text-neutral-${shade}`;
};

export const getCtaButtonColor = (color, variant) => {
  if (variant === 'filled') {
    return color === 'neutral' ? 'neutral' : color;
  }
  return color;
};

export const getCtaButtonShade = (color, variant) => {
  if (variant === 'filled') {
    return color === 'neutral' ? 600 : 400;
  }
  return 500;
};
